import { render, staticRenderFns } from "./NewMessageAudioRecorder.vue?vue&type=template&id=6e727666&scoped=true"
import script from "./NewMessageAudioRecorder.vue?vue&type=script&lang=js"
export * from "./NewMessageAudioRecorder.vue?vue&type=script&lang=js"
import style0 from "./NewMessageAudioRecorder.vue?vue&type=style&index=0&id=6e727666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e727666",
  null
  
)

export default component.exports